import Vue from 'vue'
import vuetify from '@/plugins/vuetify.js'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import '@/plugins/vueTelInputVuetify/vue-tel-input-vuetify-custom-styles.scss'

Vue.use(VueTelInputVuetify, { vuetify })
